import React from "react";
import TrafficBackInfoTable from "./TrafficBackInfoTable";

export default function TrafficBackContent() {

    const macros = [
        {name: 't1', value: '{pt_id}'},
        {name: 't2', value: '{offer_id}'},
        {name: 't3', value: '{tmpl}'},
        {name: 't4', value: '{partner_id}'},
        {name: 't5', value: '{source_id}'},
    ];

    return <div className='tab-pane fade active show pl-3'>
        <div id="tb-description">
        <p>Трафикбэк (англ. traffic back) - это трафик, который не принимается нашей партнёрской программой по тем или иным причинам, но вы можете перенаправить его на свой сайт или другую партнёрку.</p>
        <p>Если вы хотите перенаправить всех пользователей, которые не подходят под условия офферов вашей ссылки, по которой они перешли из рекламной сети, на альтернативный URL, укажите в поле Trafficback URL, на который система перенаправит ваших пользователей.</p>
        <p>Это могут быть пользователи, не попадающие в требуемые ГЕО или пользователи, перешедшие по ссылке с устройства, которое не входит в список разрешенных оператором.</p>
        <p>На ваш Traffickback URL вы будете получать код указывающий на причину ТБ</p>
        <h6 className="padding-5-10"> Макросы для передачи в ТБ:</h6>
        <div className="d-flex font-12">
        {
            macros.map(item => <div key={item.name} style={{fontWeight: 700, paddingRight: "10px"}}>{item.name + " - "}<span style={{fontWeight: 400, userSelect: 'all'}}>{item.value}</span></div>)
        }
        </div>
        <br/>
        </div>
        <TrafficBackInfoTable/>
    </div>;
}